export const personFields = `
id
          firstName
          lastName
          slug
          photo {
            getUrl
          }
`
export const getBiographyBySlug = () => {
  return `query getBiographyBySlug($slug: String!) {
    numericDocumentBySlug(slug: $slug) {
      ...on NumericDocument{
        id
        slug
        title: titleFr
        titleEn:titleEn
        text: textFr_html
        textEn: textEn_html
        resume: shortDescriptionFr
        resumeEn:shortDescriptionEn
        source
      }
      authors {
        firstName
        lastName
      }
      copyrights {
        name: nameC
      }
      translators {
        firstName
        lastName
        username
      }
      composer: subject{
        ...on Person{
          ${personFields}
                  }
      }
    }
  }`
}
